module.exports = __webpack_public_path__ + "img/job.183b1f2e.svg";